import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { UserSession } from '../models/usersession';

@Injectable()

export class UserSessionService {

  session = new UserSession();
  localStorageSessionKey: string;
  filterArr: any[];
  menuFilterArr: any[];


  constructor() {
    this.localStorageSessionKey = 'tct-' + environment.apiBaseUrl + '-AuthData';
  }

  create(session) {
    this.setLocalStorageProperties(session);
  }

  destroy() {
    this.setLocalStorageProperties(new UserSession());
    localStorage.removeItem('role');
    localStorage.clear();
  }

  load() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData;
  }

  authToken() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).authToken;
  }

  userId(): number {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? 0 : +JSON.parse(jsonData).userId;
  }

  groupId(): number {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? 0 : +JSON.parse(jsonData).groupId || 0;
  }

  getUserName() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).userFullName;
  }

  roleId(): number {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? 0 : +JSON.parse(jsonData).roleId;
  }

  roleName() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData).roleName;
  }
  getFilterregionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).filterregionId;
  }
  getFilterDivisionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).filterdivisionId;
  }
  getFilterSubDivisionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).filtersubdivisionId;
  }
  getRegionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).regionId;
  }
  getDivisionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).divisionId;
  }
  getSubDivisionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).subDivisionId;
  }

  getCurrentSubDivisionId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).currentSubDivisionId;
  }

  getClientId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).clientId;
  }

  getCurrentClientId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).currentClientId;
  }

  getCurrentClientName() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).currentClientName;
  }

  getEmail() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).email;
  }

  getLanguageType() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).languageType;
  }

  referrence2() {
    const jsonData = JSON.parse(localStorage.getItem(this.localStorageSessionKey));
    return JSON.parse(jsonData.departmentId).Services;
  }

  setLocalStorageProperties(session: any) {
    localStorage.setItem(this.localStorageSessionKey, JSON.stringify(session));
  }

  getLocalStorageWithKey(key: any) {
    return localStorage.getItem(key);
  }

  setLocalStorageWithKey(key: any, session: any) {
    localStorage.setItem(key, JSON.stringify(session));
  }

  isDynamicPassword() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData);
  }

  getPageUrl(key: any) {
    this.filterArr = [];
    const menu = JSON.parse(this.getLocalStorageWithKey('menucontrols'))
    const filterItems = menu.map(e => {
      if (e.submenu.length > 0) {
        e.submenu.forEach(element => {
          this.filterArr.push(element);
        });
      } else {
        this.filterArr.push(e);
      }

    });
    const output = this.filterArr.find(e => {
      return e.path === key;

    })



    return output.controlAccess;

  }

  getDistrictId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).districtId;
  }
  getBlockId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).blockId;
  }
  getFilterDistrictId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).filterdistrictId;
  }
  getFilterBlockId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? [] : JSON.parse(jsonData).filterblockId;
  }


}

